<template>
    <div @init-import-form="getAccountsForVendor(vendor)">
        <div class="alert alert-danger" v-if="formErrors">
            <p><strong>Whoops!</strong> Something went wrong!</p>
            <br>
            <ul>
                <li v-for="error in form.errors">
                    {{ error[0] }}
                </li>
            </ul>
        </div>

        <div class="alert alert-info" v-if="dateNotice">
            <p><strong>Heads Up!</strong> <span v-text="dateNotice"></span></p>
        </div>

        <form role="form" @submit.prevent="queueImport">
            <div class="form-group">
                <label for="account">Account</label>
                <select class="form-control" name="account" v-model="form.account">
                    <option value="all">All Accounts</option>
                    <option :value="account.account_id" v-for="account in accounts" :key="account.account_id">
                        {{ account.account_label && account.account_label !== null
                            ? `${account.client_name} (${account.account_label})`
                            : account.client_name
                        }}
                    </option>
                </select>
            </div>
            <div class="form-group">
                <label for="range">Date Range</label>
                <select class="form-control" name="range" v-model="form.dateRange">
                    <option value="Yesterday">Yesterday</option>
                    <option value="LastSevenDays">Last 7 Days</option>
                    <option value="ThisMonth">This Month</option>
                    <option value="LastMonth">Last Month</option>
                    <option value="ThisYear">This Year</option>
                    <option value="Custom">Custom</option>
                </select>
            </div>
            <div class="form-group daterange" v-show="form.dateRange == 'Custom'">
                <datepicker v-model="range.start" format="yyyy-MM-dd" icons-font="fa" placeholder="Start"></datepicker>
                <datepicker v-model="range.end" format="yyyy-MM-dd" icons-font="fa" placeholder="End"></datepicker>
            </div>
            <input type="hidden" name="vendor" :value="vendor">
            <input type="hidden" name="type" :value="type">
            <button type="submit" class="btn btn-primary" :class="{'btn-loading': loading}" :disabled="loading">Queue Import</button>
        </form>
    </div>
</template>

<script>
    import { datepicker } from 'vue-strap';

    export default {
        components: { datepicker },

        props: ['vendor','type'],

        data() {
            return {
                accounts: [],
                form: {
                    account: 'all',
                    dateRange: 'Yesterday',
                    errors: [],
                    vendor: '',
                    type: '',
                },
                range: {
                    start: '',
                    end: '',
                },
                loading: false
            };
        },

        computed: {
            dateNotice() {
                switch (this.vendor) {
                    case 'LinkedIn':
                        return 'The max date range per import is 6 months.'
                    case 'Twitter':
                        return 'The max date range per import is 7 days.'
                    case 'Quora':
                        return 'The max date range per import is 30 days.'
                    default:
                        return false;
                }
            },
            formErrors() {
                return Object.keys(this.form.errors).length > 0;
            }
        },

        created() {
            Bus.$on('init-import-form', this.getVendorDetails);
        },

        methods: {
            getVendorDetails(vendor) {
                if (vendor === 'Analytics') {
                    this.getViews();
                } else {
                    this.getAccountsForVendor(vendor);
                }
            },

            getAccountsForVendor(vendor) {
                axios.get(`/api/imports/${vendor.toLowerCase()}/accounts`)
                    .then(response => {
                        this.accounts = response.data;
                    });
                this.form.type = this.type;
            },

            getViews() {
                axios.get(`/api/imports/analytics/views`)
                    .then(response => {
                        this.accounts = response.data;
                    });
                this.form.type = this.type;
            },

            queueImport() {
                this.loading = true;
                let request = this.buildRequest();
                axios.post('/api/imports/queue/add', request)
                    .then(({data}) => {
                        Bus.$emit('import-queued');
                        Bus.$emit('show-success-alert', data.message);
                        this.reset();
                    })
                    .catch(error => {
                        this.form.errors = error.response.data.errors;
                        this.loading = false;
                    });
            },

            buildRequest() {
                let range = this.form.dateRange !== 'Custom' ? this.form.dateRange : JSON.stringify(this.range);
                return {
                    account: this.form.account,
                    vendor: this.vendor,
                    type: this.type,
                    dateRange: range
                };
            },

            reset() {
                Object.assign(this.$data, this.$options.data());
            }
        }
    }
</script>

<style scoped lang="scss">
    .daterange {
        div {
            width: 49%;

            &:not(:first-child) {
				float: right;
			}
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/imports/ProcessImportForm.vue